export default {
    bindings: {
        upload: '<',
        ownerName: '<',
        school: '<',
    },
    templateUrl: `admin/bulk-upload/abu-order-detail/abu-order-detail-component.html`,
};
